"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ArrayUtil = /** @class */ (function () {
    function ArrayUtil() {
    }
    ArrayUtil.max = function (arr) {
        return Math.max.apply(Math, arr);
    };
    ArrayUtil.is_empty = function (arr) {
        return this.length === 0;
    };
    ArrayUtil.random = function (arr) {
        return arr[Math.floor(Math.random() * arr.length)];
    };
    ArrayUtil.first = function (arr) {
        return arr[0];
    };
    ArrayUtil.last = function (arr) {
        return arr[this.length - 1];
    };
    return ArrayUtil;
}());
exports.ArrayUtil = ArrayUtil;
